import Vue from 'vue';
import Router from 'vue-router';
const Home = () => import( '@/views/Home.vue')
const Detail = () => import( '@/views/Detail.vue')
const Success = () => import( '@/views/Success.vue')
const Fail = () => import( '@/views/Fail.vue')
const Abort = () => import('@/views/Abort.vue')
const Help = () => import('@/views/Help.vue')
const Contact = () => import('@/views/Contact.vue')
const Imprint = () => import('@/views/Imprint.vue')
const Privacy = () => import('@/views/Privacy.vue')
const Conditions = () => import('@/views/Conditions.vue')
const Withdrawal = () => import('@/views/Withdrawal.vue')

Vue.use(Router);

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes :[
    {
      path: '/',
      name: 'Home',
      component: Home
    }, {
      path: '/detail/:id',
      name: 'Detail',
      component: Detail
    }, {
      path: '/success/:token',
      name: 'Success',
      component: Success
    }, {
      path: '/fail/:token',
      name: 'Fail',
      component: Fail
    }, {
      path: '/abort/:token',
      name: 'Abort',
      component: Abort
    },

    {
      path: '/help',
      name: 'Help',
      component: Help
    }, {
      path: '/contact',
      name: 'Contact',
      component: Contact
    }, {
      path: '/imprint',
      name: 'Imprint',
      component: Imprint
    }, {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy
    }, {
      path: '/conditions',
      name: 'Conditions',
      component: Conditions
    }, {
      path: '/withdrawal',
      name: 'Withdrawal',
      component: Withdrawal
    }, 
  ]
});

export default router
